export const PermissionsEnum = Object.freeze({
    newTestimonial: "create_testimonial",
    shareTestimonial: "share_testimonial",
    viewSettings: "view_settings",
    createAuthor: "create_author",
    reviewTestimonials: "review_testimonial",
    viewUsers: "view_users",
    viewOptions: "view_options",
    createOption: "create_option",
    editOption: "edit_option",
    editUserPermissions: "edit_user_permissions",
    editUser: "edit_user_details",
    bulkUploadTestimonials: "bulk_upload_testimonials",
});
